// Attori segnalanti per cui la data di dimissione al completamento è facoltativa
// (il paziente può essere già a domicilio).
const OPTIONAL_DISCHARGE_ACTOR_CODES = ['PUA', 'MMG'];

/**
 * Indica se data e ora di dimissione sono obbligatorie per completare la pratica.
 * Il segnalante è identificato da `creator.actorId`, risolto sulla lista di `/v1/actor/find`.
 * In mancanza di informazioni la data resta obbligatoria.
 */
export function isDischargeDateRequired(
  creator: { actorId?: number | string } | null | undefined,
  actors: { id?: number | string; code: string }[] | null | undefined
): boolean {
  if (creator?.actorId == null || !actors?.length) return true;
  const actor = actors.find((a) => String(a.id) === String(creator.actorId));
  return !actor || !OPTIONAL_DISCHARGE_ACTOR_CODES.includes(actor.code?.toUpperCase());
}
